import React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

const SearchIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 60 60" {...props} style={{ fill: "none" }}>
            <circle
                cx="27.5"
                cy="24.5"
                r="17.5"
                stroke="#585858"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M53 52L39 38" stroke="#585858" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
        </SvgIcon>
    );
};

export default SearchIcon;
